import get from 'lodash/get';
import omitBy from 'lodash/omitBy';
import isNil from 'lodash/isNil';
import pick from 'lodash/pick';

import { api } from '$app/api';

const pickEditableProduct = (product) => {
  const clean = omitBy(product, isNil);
  return pick(clean, [
    'categories',
    'label_customer',
    'label_mechanic',
    'long_description',
    'product_number',
    'search_terms',
    'short_description',
    'sku',
    'segment',
  ]);
};

export const getErrorMessage = (error) =>
  get(error, 'response.data.details', error.message || 'Something went wrong');

export async function fetchProducts() {
  const { data } = await api('/product', {
    method: 'post',
    data: {
      eventType: 'ListProductsRequest',
      body: {},
    },
  });

  return data;
}

export async function fetchCatalogs() {
  const { data } = await api('/product', {
    method: 'post',
    data: {
      eventType: 'GetCatalogsRequest',
      body: {},
    },
  });

  return data.catalogs;
}

export async function fetchCatalogIdsBySku(sku) {
  const { data } = await api('/product', {
    method: 'post',
    data: {
      eventType: 'GetCatalogsBySkuRequest',
      body: { sku },
    },
  });

  return data.catalogs.map((catalog) => catalog.catalogId);
}

export async function createProduct(payload) {
  await api('/product', {
    method: 'post',
    data: {
      eventType: 'AddProductRequest',
      body: {
        product: pickEditableProduct(payload.product),
      },
    },
  });
}

export async function updateProduct(payload) {
  const { product, catalogs } = payload || {};

  if (!product || !product.sku) {
    throw new Error('Product SKU is required.');
  }

  await api('/product', {
    method: 'post',
    data: {
      eventType: 'UpdateProductRequest',
      body: {
        product: pickEditableProduct(product),
        catalogs,
      },
    },
  });
}

export async function deleteProduct(sku) {
  if (!sku) {
    throw new Error('Product SKU is required.');
  }

  await api(`/product/product?sku=eq.${sku}`, {
    method: 'delete',
  });
}

export async function fetchPredefinedPrices() {
  const { data } = await api('/price-list/allPredefinedOperations');
  return data;
}

export async function fetchPredefinedPrice(predefinedId) {
  const { data } = await api(`/price-list/predefinedOperations/${predefinedId}`);
  return data;
}

export async function createPredefinedPrice(sku, formData) {
  const price = {
    ...formData,
    predefinedId: `${sku}-${(formData.description || '').substring(0, 5)}-${Date.now()}`.toUpperCase(),
    sku,
    status: 'active',
  };

  switch (price.type) {
    case 'MOT':
      price.vatExempt = true;
      price.accountCode = 201;
      price.accountCodePurchases = 311;
      price.itemCode = 'MOT Purchase';
      break;
    case 'Service':
      price.vatExempt = false;
      price.accountCode = 202;
      price.accountCodePurchases = 312;
      price.itemCode = 'Periodic Service';
      break;
    default:
      price.vatExempt = false;
      price.accountCode = 203;
      price.accountCodePurchases = 313;
      break;
  }

  await api(`/price-list/predefinedOperations/${sku}`, {
    method: 'post',
    data: price,
  });
}

export async function updatePredefinedPrice(predefinedId, formData) {
  await api(`/price-list/predefinedOperations/${predefinedId}`, {
    method: 'patch',
    data: formData,
  });
}
